import { useNavigate, useParams } from 'react-router-dom';
import { AppProps } from '../../App'
import MainWrapper from '../../components/MainWrapper'
import { useEffect } from 'react';
import General from './General';
import PlanAndPayments from './PlanAndPayments';

const Settings = (props: AppProps) => {

  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!props.user) {
      navigate('/signin');
    }
  }, [props.user, navigate]);

  return (
    props.user ?
      <MainWrapper {...props}>
        {!params.option ? <General {...props} />
          : params.option === 'plan-and-payments' ? <PlanAndPayments {...props} />
          : <></>}
      </MainWrapper>
      : <></>
  )
}

export default Settings